import { useSelector } from "react-redux";
import {
  selectReportingPeriodTextInfo,
  selectReportingPeriodIsOpen,
  selectActiveReportingPeriod,
  selectRenderPaths,
} from "../../services/submissionPeriod/slices";
import Card from "../../Common/components/Card";
import { Mui, MuiIcons } from "@osu/react-ui";
import { NavLink } from "react-router-dom";
import {
  selectCanCreateForms,
  selectIsLoggedIn,
} from "../../services/authorization/slices";
import { formatStartEnd } from "../../util/functions";
import { ROUTE_KEYS, ROUTES } from "../../_configuration/routing/constants";
import OpenFormsLinks from "../../Common/components/OpenFormsLinks";
import { Fragment } from "react/jsx-runtime";
import NoAccess from "./NoAccess";

const selectorEq = (a, b) => {
  return a?.title === b?.title && a?.description === b?.description;
};

const Links = () => {
  const isOpen = useSelector(selectRenderPaths);
  if (!isOpen) {
    return false;
  }
  return (
    <Mui.Box
      component="section"
      sx={{
        paddingTop: 1,
      }}
    >
      <Mui.Typography sx={{ pb: 1 }} variant="subtitle1">
        Available Forms
      </Mui.Typography>
      <OpenFormsLinks />
    </Mui.Box>
  );
};

function ReportingOpen({ loading }) {
  const { title, description } = useSelector(
    selectReportingPeriodTextInfo,
    selectorEq
  );
  const canCreate = useSelector(selectCanCreateForms);
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isPeriodActive = useSelector((state) => {
    return selectReportingPeriodIsOpen(state) && !!title;
  });
  const notLoggedInText = useSelector((state) => {
    if (isLoggedIn) {
      return "";
    }
    const { start, end, isActive } = selectActiveReportingPeriod(state);
    const range = formatStartEnd({
      delimeter: "to",
      start,
      end,
    });
    if (!isActive) return "";
    return `The ${range} reporting period is open. Please sign in to submit your entries.`;
  });
  if (loading) {
    return (
      <Card Icon={MuiIcons.AccessTime} title={<Mui.Skeleton width="50%" />}>
        <Mui.Skeleton />
        {isLoggedIn && (
          <Mui.Box>
            <Mui.Skeleton width="50%" />
            <Mui.Skeleton width="80%" />
            <Mui.Skeleton width="80%" />
          </Mui.Box>
        )}
      </Card>
    );
  }

  if (!isPeriodActive) {
    return (
      <Card Icon={MuiIcons.AccessTime} title={"Reporting Closed"}>
        Reporting is not open for submissions.
      </Card>
    );
  }

  if (notLoggedInText) {
    return (
      <Card Icon={MuiIcons.AccessTime} title={title}>
        <Mui.Typography>{notLoggedInText}</Mui.Typography>
        <Mui.Button
          sx={{ marginTop: 2 }}
          variant="contained"
          component={NavLink}
          to={ROUTES[ROUTE_KEYS.LOGIN].path}
        >
          Sign In
        </Mui.Button>
      </Card>
    );
  }

  return (
    <Card Icon={MuiIcons.AccessTime} title={title}>
      {canCreate ? (
        <Fragment>
          {description}
          <Links />
        </Fragment>
      ) : (
        <NoAccess />
      )}
    </Card>
  );
}

export default ReportingOpen;
